<ion-app>
	<div class="ehe">
		<ion-router-outlet></ion-router-outlet>
	</div>
	<!--<app-ehe-footer></app-ehe-footer>-->
</ion-app>
